<template>
  <div class="custom-checkbox">
    <label
      v-for="option in options"
      :key="option.value"
      class="flex cursor-pointer select-none items-center justify-between">
      <input
        type="checkbox"
        :value="option.value"
        v-model="selectedOptions"
        class="hidden"
        @change="updateSelectedValues" />

      <span :class="labelClass" class="gc-font-main-text text-sm">
        {{ option.label }}
      </span>

      <div
        class="flex h-5 w-5 items-center justify-center rounded-full border-2"
        :class="{
          'border-brand': selectedOptions.includes(option.value),
          'border-dark': !selectedOptions.includes(option.value),
        }">
        <div
          v-if="selectedOptions.includes(option.value)"
          class="h-3 w-3 rounded-full bg-brand" />
      </div>
    </label>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const emit = defineEmits(['update:selectedOptions']);

const props = defineProps({
  options: {
    type: Object,
    required: true,
  },
  defaultValues: {
    type: Array,
    default: () => [],
  },
  labelClass: {
    type: String,
    default: '',
  },
});

const selectedOptions = ref([...props.defaultValues]);

const updateSelectedValues = () => {
  emit('update:selectedOptions', selectedOptions.value);
};
</script>
